import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import AvailabilityError from '~/constants/availabilityError';
import { useUserId, useUserLocation } from '~/context/common/UserContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import { useGetVehicleId } from '~/context/vdp/VehicleContext';
import fetchUserVehicleAvailability from '~/services/vdp/fetchVehicleAvailability';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetVehicleAvailability() {
  const {
    fetchVehicleAvailabilityFlag,
    vehicleAvailability: { setData, setError, setLoading }
  } = useContext(UserVehicleContext);
  const vehicleId = useGetVehicleId();
  const userId = useUserId();
  const { zip } = useUserLocation();

  useEffectWithController(
    controller => {
      if (!zip) return;

      setLoading();

      fetchUserVehicleAvailability({ userId, vehicleId, zip }, controller)
        .then(res => {
          const isPendingDealerPurchase = Boolean(
            res.dealerPurchaseInitiatedByUserId &&
              res.isDealerPurchased === null
          );
          const isPendingDealerPurchaseByUser = Boolean(
            isPendingDealerPurchase &&
              res.dealerPurchaseInitiatedByUserId === res.userId
          );

          return setData({
            ...res,
            error:
              res.error === AvailabilityError.None &&
              isPendingDealerPurchase &&
              !isPendingDealerPurchaseByUser
                ? AvailabilityError.PurchasePending
                : res.error || AvailabilityError.None,
            isPendingDealerPurchase,
            isPendingDealerPurchaseByUser
          });
        })
        .catch(
          generateErrorLogger(
            'Get vehicle availability',
            {},
            { callback: setError, controller }
          )
        );
    },
    [
      fetchVehicleAvailabilityFlag,
      setData,
      setError,
      setLoading,
      userId,
      vehicleId,
      zip
    ]
  );
}
